var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"color":_vm.updateIconColor(_vm.value)}},[_vm._v("\n  "+_vm._s(_vm.updateIcon(_vm.value))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }